// extracted by mini-css-extract-plugin
module.exports = {"home":"AuroraHome_home__7t0Fb"};